<template>
    <div>
      <div>
          <section v-if="!initialLoading">
          <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                    <table
                    id="data-table-list-courses"
                    class="table-hover-animation table-striped table-bordered"
                    >
                      <thead>
                          <tr>
                            <th>ID</th>
                            <th>Nombres</th>
                            <th>Teléfono</th>
                            <th>Correo</th>
                            <th>Fecha de solicitud</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="query in queries" :key="query.id">
                            <td>{{query.id}}</td>
                            <td>{{query.fullname}}</td>
                            <td>{{query.phone}}</td>
                            <td>{{query.email}}</td>
                            <td>{{ moment(query.created_at).format('DD/MM/YYYY hh:mm A')}}</td>
                          </tr>
                      </tbody>
                    </table>
                </div>
              </div>
          </div>
          </section>
          <custom-spinner v-else></custom-spinner>
      </div>
    </div>
  </template>
  <script>
  import moment from 'moment';
  import ModalComponent from '../ModalComponent.vue';
  import CustomSpinner from '../../common/custom-spinner/CustomSpinner.vue';
  import language from '../../api/traduction_es';
  
  export default {
    data() {
      return {
        initialLoading: false,
        moment: moment,
        queriess: [],
      };
    },
    components: {
      'custom-modal': ModalComponent,
      'custom-spinner': CustomSpinner,
    },
  
    mounted() {
    this.getQueries();
    },
  
    methods: {
      loadDataTable() {
        $(document).ready( function () {
            $('#data-table-list-courses').DataTable(language);
        });
      },
      async getQueries(){
          this.initialLoading = true;
          await axios.get('/queries/gift-pdf').then((response) => {
              this.queries = response.data;
              this.initialLoading = false;
              this.loadDataTable();
          });
      }
    },
  };
  </script>
  <style>
  .el-select {
    width: 80%;
  }
  .el-select .el-input .el-select__caret::before {
    content: '\e794';
  }
  
  #customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
  }
  </style>
  